import React from 'react';
import axios from 'axios';
import * as Globals from '../Globals';


export default class Training extends React.Component {

    constructor(props) {
        super(props);
        this.userID = this.props.userID;
        this.status = 'CHOOSING';
        this.subjectIDs = [];
        this.choosenBox = undefined;
        this.questionID = undefined;
        this.rightAnswers = undefined;
        this.questionExplanation = '';
        this.maxCount = 0;
        this.showExplanation = false;
        this.answeredQuestionCount = 0;
        this.boxNames = [
            "Nicht geübt",
            "Nicht ausreichend",
            "Genügend",
            "Befriedigned",
            "Gut",
            "Sehr gut",
        ];
        this.state = {
            subjects: [],
            boxes: [
                {questionCount: 0},
                {questionCount: 0},
                {questionCount: 0},
                {questionCount: 0},
                {questionCount: 0},
                {questionCount: 0}
            ],
            question: {
                text: '',
                imagePath: '',
                answers: []
            }
        };
    }


    componentDidMount() {
        this.getSubjects();
    }

    getSubjects() {
        let cookie = this.props.LogoutOnCookieNotSet();
        axios.get(Globals.EL_PATH + 'user/' + this.userID + '/subject?Authentication=' + cookie
        ).then(response => {
            let fecthedSubjects = response.data.records;
            let subjects = [];
            fecthedSubjects.map(subject => {
                this.subjectIDs.push(subject.subject_id);
                subjects.push({
                    id: subject.subject_id,
                    name: subject.subject_name,
                    visible: subject.subject_visible,
                    subSubjects: subject.subject_sub_subjects,
                    checked: false
                });
                return null;
            });
            this.setState({subjects: subjects});
        }).catch(error => {
            this.props.CheckAuthError(error);
        })
    }

    getSelectSubjectIDs() {
        let selectedStubjectIDs = [];
        this.state.subjects.map((subject, index) => {
            if (subject.checked)
                selectedStubjectIDs.push(subject.subSubjects.length? subject.subSubjects : subject.id);
            return null;
        });
        return selectedStubjectIDs;
    }

    getBoxes() {
        let selectedStubjectIDs = this.getSelectSubjectIDs();
        if (selectedStubjectIDs.length !== 0) {
            let subjects = '';
            selectedStubjectIDs.map((subject, index) => {
                if (index === 0)
                    subjects += subject;
                else
                    subjects += ',' + subject;
                return null;
            });
            let cookie = this.props.LogoutOnCookieNotSet();
            axios.get(Globals.EL_PATH + 'questiontraining/overview?USER_ID=' + this.userID + '&SUBJECT_ID=' + subjects + '&Authentication=' + cookie
            ).then(response => {
                let fetchedBoxes = response.data.records;
                let boxes = this.state.boxes;
                fetchedBoxes.map((box, index) => {
                    boxes[index].questionCount = box;
                    return null;
                });
                this.calcMaxCount(boxes);
                this.setState({boxes: boxes});
            }).catch(error => {
                this.props.CheckAuthError(error);
            })
        }
    }

    handleCheckedSubjectChange(index) {
        let subjects = this.state.subjects;
        subjects[index].checked = !subjects[index].checked;
        this.setState({subjects: subjects});
        this.getBoxes();
    }

    changeSelectedBox(level) {
        this.choosenBox = level;
        this.status = 'TRAINING';
        this.initQuestion();
    }

    initQuestion() {
        let selectedStubjectIDs = this.getSelectSubjectIDs();
        let cookie = this.props.LogoutOnCookieNotSet();
        let subjects = '';
        selectedStubjectIDs.map((subject, index) => {
            if (index === 0)
                subjects += subject;
            else
                subjects += ',' + subject;
            return null;
        });
        if (this.choosenBox !== undefined) {
            axios.get(Globals.EL_PATH + 'questiontraining/level/' + this.choosenBox + '?USER_ID=' + this.userID + '&SUBJECT_ID=' + subjects + '&Authentication=' + cookie
            ).then(response => {
                this.questionID = response.data.records.question_id;
                this.questionExplanation = response.data.records.answer_explanation;
                this.rightAnswers = [];
                let answers = [];
                response.data.records.answers.map((answer, index) => {
                    answers.push({text: answer.answer_text, checked: false});
                    if (answer.answer_is_true === 1) {
                        this.rightAnswers.push(index);
                    }
                    return null;
                });
                let question = {
                    text: response.data.records.question_text,
                    imagePath: response.data.records.img_source,
                    answers: answers
                };
                this.setState({question: question});
            }).catch(error => {
                this.props.CheckAuthError(error);
                if (error.response.data.message === 'No questions found.') {
                    this.status = 'BOX_FINISHED';
                    this.forceUpdate();
                }
            });
        } else {
            axios.get(Globals.EL_PATH + 'questiontraining/level?USER_ID=' + this.userID + '&SUBJECT_ID=' + subjects + '&Authentication=' + cookie
            ).then(response => {
                this.questionID = response.data.records.question_id;
                this.questionExplanation = response.data.records.answer_explanation;
                this.rightAnswers = [];
                let answers = [];
                response.data.records.answers.map((answer, index) => {
                    answers.push({text: answer.answer_text, checked: false});
                    if (answer.answer_is_true === 1) {
                        this.rightAnswers.push(index);
                    }
                    return null;
                });
                let question = {
                    text: response.data.records.question_text,
                    imagePath: response.data.records.img_source,
                    answers: answers
                };
                this.setState({question: question});
            }).catch(error => {
                this.props.CheckAuthError(error);
                if (error.response.data.message === 'No questions found.') {
                    this.status = 'BOX_FINISHED';
                    this.forceUpdate();
                }
            });
        }
    }

    calcMaxCount(boxes) {
        this.maxCount = 0;
        boxes.map(box => {
            if (box.questionCount > this.maxCount) {
                this.maxCount = box.questionCount;
            }
            return null;
        });
    }

    trainAll() {
        this.choosenBox = undefined;
        this.status = 'TRAINING';
        this.initQuestion();
    }

    getBoxesOverview() {
        if (this.getSelectSubjectIDs().length !== 0) {
            return (
                <div className="successView">
                    <h3 className="margin-top-lg text-center margin-bottom-md">Fortschrittsübersicht</h3>

                    <div className="modal fade" id="myModal" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span></button>
                                    <h4 className="modal-title" id="myModalLabel">Boxsystem Erklärung</h4>
                                </div>
                                <div className="modal-body">
                                    Das Boxsystem soll Ihnen eine Übersicht über den derzeitigen Lernfortschritt
                                    geben. Jedes Mal, wenn Sie eine Fragen beantworten, wird die Frage ausgewertet
                                    und das Boxsystem angepasst. Dabei ist die Nummerierung der Boxen wichtig, je höher
                                    die Stufe der Box, desto besser können Sie die Fragen, die sich in dieser Box
                                    befinden.
                                    Das würde also heißen, dass es von Vorteil wäre, primär die Fragen der niedrigen
                                    Boxen zu wiederholen. <b><i>"Noch nicht geübt" steht hierbei für die Fragen, die Sie noch nie
                                    gelernt haben.</i></b>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn center-block btn-default"
                                            data-dismiss="modal">Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button data-toggle="modal"
                            data-target="#myModal" className="help-button">Hilfe</button>
                    <p className="text-center"><b>Wenn Sie die Fragen einer bestimmten Box lernen möchten, können Sie
                        auf die gewünschte Box klicken.</b></p>
                    <div className="training-boxes">
                    {
                        this.state.boxes.map((box, index) => {
                            if (box.questionCount === 0) {
                                return (
                                    <div key={index}>
                                        <div className="questionCount-container-head" style={{opacity: 0.6}}>
                                            <div className="questionCount" key={index}>
                                                <span><b>Box {this.boxNames[index]}: {box.questionCount} Fragen</b></span>
                                                <div className="questionCount-progress"
                                                     style={{width: (this.maxCount !== 0) ? ((box.questionCount / this.maxCount) * 100) + '%' : '0%'}}/>
                                            </div>
                                        </div>
                                    </div>
                                );
                            } else {
                                return (
                                    <div key={index}>
                                        <div className="questionCount-container">
                                            <div className="questionCount" style={{cursor: 'pointer'}} key={index}
                                                 onClick={() => this.changeSelectedBox(index)}>
                                                <span><b>Box {this.boxNames[index]}: {box.questionCount} Fragen</b></span>
                                                <div className="questionCount-progress"
                                                     style={{width: ((box.questionCount / this.maxCount) * 100) + '%'}}/>
                                            </div>
                                        </div>
                                    </div>
                                );
                            }
                        })
                    }
                    </div>
                    <button onClick={() => this.trainAll()} className="btn btn-info center-block margin-top-md">Alle
                        trainieren
                    </button>
                </div>
            );
        }
    }

    handleFinished() {
        this.status = 'CHOOSING';
        this.choosenBox = undefined;
        this.answeredQuestionCount = 0;
        this.getBoxes();
    }

    handleCheckboxChange(index) {
        let question = this.state.question;
        question.answers[index].checked = !question.answers[index].checked;
        this.setState({question: question});
    }

    nextQuestion() {
        if (this.showExplanation === false) {
            this.showExplanation = true;
            this.forceUpdate();
        } else {
            this.showExplanation = false;
            if (this.choosenBox === 5 && this.answeredQuestionCount >= this.state.boxes[5].questionCount){
                this.status = 'BOX_FINISHED';
                this.forceUpdate();
            }
            this.sendQuestion();
        }
    }

    cancelTraining() {
        this.handleFinished();
    }

    isRightAnswered() {
        let answered_right = true;
        this.state.question.answers.map((answer, index) => {
            if (answer.checked) {
                if (!this.rightAnswers.includes(index)) {
                    answered_right = false;
                }
            } else {
                if (this.rightAnswers.includes(index)) {
                    answered_right = false;
                }
            }
            return null;
        });
        return answered_right;
    }

    isAnsweredRight(index) {
        return this.rightAnswers.includes(index);
    }

    sendQuestion() {
        let cookie = this.props.LogoutOnCookieNotSet();
        let answered_right = this.isRightAnswered();
        if (this.choosenBox === 5 && answered_right){
            this.answeredQuestionCount++;
        }
        axios.post(Globals.EL_PATH + 'questiontraining/level?USER_ID=' + this.userID + '&Authentication=' + cookie, {
            QUESTION_ID: this.questionID,
            ANSWERED_RIGHT: answered_right
        }).then(() => {
            this.initQuestion();
        }).catch(error => {
            this.props.CheckAuthError(error);
        });
    }

    getQuestion() {
        if (!this.showExplanation) {
            return (
              <div className="question margin-top-lg">
                <div className="well">
                  <h4 className="margin-bottom-md text-center">{this.state.question.text}</h4>
                  {this.state.question.imagePath !== null ? (
                    <img alt="" src={Globals.EL_PATH + this.state.question.imagePath} />
                  ) : null}
                  {this.state.question.answers.map((answer, index) => {
                    return (
                      <div
                        key={index}
                        className="checkbox padding-sm margin-top-sm"
                        style={{ width: "100%" }}
                      >
                        <label className="checkbox-label full-width">
                          <input
                            className="customCheckbox"
                            type="checkbox"
                            checked={answer.checked}
                            onChange={() => this.handleCheckboxChange(index)}
                          />
                          <span className="label-text">{answer.text}</span>
                        </label>
                      </div>
                    );
                  })}
                </div>
                <button
                  className="btn btn-info center-block margin-top-md"
                  type="button"
                  onClick={() => this.nextQuestion()}
                >
                  Kontrollieren
                </button>
                <button
                  className="btn btn-danger center-block margin-top-md"
                  type="button"
                  onClick={() => this.cancelTraining()}
                >
                  Abbrechen
                </button>
              </div>
            );
        } else {
            return (
                <div className="question margin-top-lg">
                    <div className="well">
                        <h4 className="margin-bottom-md text-center">{this.state.question.text}</h4>
                        {(this.state.question.imagePath !== null) ?
                            <img alt="" src={Globals.EL_PATH + this.state.question.imagePath}/> : null}
                        {
                            this.state.question.answers.map((answer, index) => {
                                return (
                                    <div key={index} className="checkbox padding-sm margin-top-sm"
                                         style={{width: '100%'}}>
                                        <label className="checkbox-label full-width" style={{
                                            borderWidth: '2px',
                                            borderColor: (this.isAnsweredRight(index)) ? 'rgba(37, 159, 108, 1)' : 'rgba(255, 81, 81, 1)'
                                        }}>
                                            <input className="customCheckbox" type="checkbox" checked={answer.checked}
                                                   onChange={() => this.handleCheckboxChange(index)}/>
                                            <span className="label-text">{answer.text}</span>
                                        </label>
                                    </div>
                                );
                            })
                        }
                    </div>
                    {
                        (this.questionExplanation !== '') ?
                            <div className="alert alert-info text-center"><b>Erklärung: </b>{this.questionExplanation}
                            </div>
                            : <div className="alert alert-info text-center">Keine Erklärung verfügbar...</div>
                    }
                    <button className="btn btn-info center-block margin-top-md" type="button"
                            onClick={() => this.nextQuestion()}>Nächste Frage
                    </button>
                    <button className="btn btn-danger center-block margin-top-md" type="button"
                            onClick={() => this.cancelTraining()}>Abbrechen
                    </button>
                </div>
            );
        }
    }


    render() {
        if (this.status === 'CHOOSING') {
            return (
                <div className="container questiontraining">
                    <h1 className="text-center">Fragentraining</h1>
                    <p className="margin-top-lg text-center margin-bottom-md choose-center"><b>Wählen Sie, aus welchen
                        Fächern Fragen ausgewählt werden sollen.</b></p>
                    {
                        this.state.subjects.map((subject, index) => {
                            return !subject.visible ? null : (
                                <button key={index} className={`checkbox-label ${subject.checked ? "selected" : ""}`} onClick={() => this.handleCheckedSubjectChange(index)}>
                                    <span className="label-text">{subject.name}</span>
                                </button>
                            );
                        })
                    }
                    {this.getBoxesOverview()}
                </div>
            );
        }
        if (this.status === 'TRAINING') {
            return (
                <div className="container questiontraining">
                    <h1 className="text-center">Fragentraining</h1>
                    {this.getQuestion()}
                </div>
            );
        }
        if (this.status === 'BOX_FINISHED') {
            return (
                <div className="container questiontraining">
                    <h1 className="text-center">Fragentraining</h1>
                    <h4 className="text-center">Keine weiteren Fragen in dieser Box.</h4>
                    <button className="btn btn-info center-block margin-top-md"
                            onClick={() => this.handleFinished()}>Zurück
                    </button>
                </div>
            );
        }
        return <div/>;
    }

}



// WEBPACK FOOTER //
// ./src/user/Training.js